import PageHero from "@/components/PageHero";
import CTABand from "@/components/CTABand";
import { Reveal } from "@/components/Reveal";
import { useSEO } from "@/hooks/useSEO";
import { IMG, MISSION, VALUES_FULL, TARGET_MARKET } from "@/lib/site";
import { Check } from "lucide-react";

export default function Tentang() {
  useSEO(
    "Tentang Kami",
    "HATTORY KONVEKSI — perusahaan konveksi modern yang membangun sistem operasional berbasis teknologi. Kenali visi, misi, nilai, dan target pasar kami."
  );

  return (
    <>
      <PageHero
        overline="Tentang Kami"
        titleLines={["Membangun", "Konveksi Modern"]}
        description="Kami tidak hanya memproduksi pakaian, tetapi membangun sistem operasional modern agar seluruh proses berjalan efisien, transparan, dan berbasis data."
      />

      <div className="mx-auto max-w-7xl px-6 py-20 md:px-12 md:py-28">
        {/* Story */}
        <div className="grid gap-12 md:grid-cols-12 md:gap-16">
          <Reveal className="md:col-span-7">
            <p className="text-xs font-bold uppercase tracking-[0.25em] text-silver">Cerita Kami</p>
            <p className="mt-6 text-2xl font-medium leading-relaxed tracking-tight text-navy md:text-3xl">
              HATTORY KONVEKSI adalah perusahaan konveksi modern yang bergerak di bidang produksi pakaian custom dengan mengutamakan kualitas, kecepatan pelayanan, dan profesionalisme.
            </p>
            <p className="mt-5 leading-relaxed text-charcoal/80">
              HATTORY KONVEKSI tidak hanya memproduksi pakaian, tetapi membangun sistem operasional yang modern sehingga seluruh proses berjalan efisien, transparan, dan berbasis data.
            </p>
          </Reveal>
          <Reveal delay={0.15} className="md:col-span-5">
            <div className="overflow-hidden rounded-3xl shadow-soft">
              <img src={IMG.factory} alt="Produksi HATTORY" className="h-[380px] w-full object-cover" />
            </div>
          </Reveal>
        </div>

        {/* Vision */}
        <Reveal>
          <div className="relative mt-20 overflow-hidden rounded-3xl bg-navy p-10 md:p-16" data-testid="vision-block">
            <div className="grain absolute inset-0" />
            <div className="relative z-10">
            <p className="text-xs font-bold uppercase tracking-[0.25em] text-silver">Visi</p>
            <p className="mt-5 max-w-4xl text-2xl font-bold leading-snug tracking-tight text-white md:text-4xl">
              Menjadi perusahaan konveksi modern berskala nasional yang memiliki jaringan showroom di berbagai kota di Indonesia dengan satu sistem operasional yang terintegrasi, profesional, efisien, dan berbasis teknologi.
            </p>
            </div>
          </div>
        </Reveal>

        {/* Mission */}
        <section className="mt-20">
          <Reveal><h2 className="text-3xl font-black tracking-tight text-navy md:text-4xl">Misi</h2></Reveal>
          <div className="mt-8 grid gap-4 md:grid-cols-2">
            {MISSION.map((m, i) => (
              <Reveal key={i} delay={(i % 2) * 0.08}>
                <div className="flex items-start gap-4 rounded-2xl border border-silver/30 p-6">
                  <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-navy text-white">
                    <Check className="h-4 w-4" />
                  </span>
                  <p className="leading-relaxed text-charcoal">{m}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </section>

        {/* Values */}
        <section className="mt-20">
          <Reveal><h2 className="text-3xl font-black tracking-tight text-navy md:text-4xl">Nilai Perusahaan</h2></Reveal>
          <div className="mt-8 flex flex-wrap gap-3" data-testid="values-list">
            {VALUES_FULL.map((v, i) => (
              <Reveal key={v} delay={(i % 5) * 0.05}>
                <span className="inline-block rounded-full bg-surface px-6 py-3 font-medium text-navy transition-colors hover:bg-navy hover:text-white">
                  {v}
                </span>
              </Reveal>
            ))}
          </div>
        </section>

        {/* Target market */}
        <section className="mt-20">
          <Reveal><h2 className="text-3xl font-black tracking-tight text-navy md:text-4xl">Target Pasar</h2></Reveal>
          <div className="mt-8 flex flex-wrap gap-3" data-testid="target-market-list">
            {TARGET_MARKET.map((t, i) => (
              <Reveal key={t} delay={(i % 6) * 0.04}>
                <span className="inline-block rounded-full border border-silver/60 px-5 py-2.5 text-sm font-medium text-charcoal">
                  {t}
                </span>
              </Reveal>
            ))}
          </div>
        </section>
      </div>

      <CTABand />
    </>
  );
}
